import { FC, useState } from "react";
import {
  selectAssessments,
  selectClassRooms, selectLoading
} from "app/reducer/assessmentSlice";
import { useAppSelector } from "app/hooks";
import AssessmentModal from "./assessmentModal";
import RefreashIcon from "assets/img/refresh-icon.png";

const SelectAssessmentModal: FC = () => {

  const classRooms = useAppSelector(selectClassRooms);
  const assessments = useAppSelector(selectAssessments);
  const [classId, setClassId] = useState(-1);
  const loading = useAppSelector(selectLoading);

  return (
    <>
      <AssessmentModal setClassId={setClassId} classId={classId} />
      {(!classRooms.length || (classId >-1 && !assessments.length)) && !loading && (
        <div className="permission">
          <div className="permission-text classroom-permission">
              <p>
                You don’t currently have any assessments available. 
                Ask your teacher to assign an assessment to you and then use the refresh button
                <img src={RefreashIcon} alt="Test icon"  />
                above to refresh the available assessments.
              </p>
          </div>
        </div>
      )}
    </>
  );
};

export default SelectAssessmentModal;
